import React from "react"
import { Helmet } from "react-helmet"
import { usePageContext } from "./Layout";



export interface SeoProps {

}


export function Seo(props: SeoProps) {
	const { pageMeta, siteMeta } = usePageContext();

	const lang = pageMeta.lang;
	const pageTitle = pageMeta.title;
	
	const siteTitle = siteMeta.title.find(v => v.lang === lang)?.value ?? '';
	const siteDescription = siteMeta.description.find(v => v.lang === lang)?.value ?? '';
	
	const title = pageTitle ? `${pageTitle} | ${siteTitle}` : siteTitle;
	const description = pageMeta.description || siteDescription;
	const robots = pageMeta.robots || 'index, follow';
	
	const altLinks = pageMeta.alts.map(alt => ({
		rel: 'alternate',
		hrefLang: alt.lang,
		href: new URL(alt.url, siteMeta.siteUrl).toString(),
	}))

	return (
		<Helmet
			htmlAttributes={{lang}}
			title={title}
			meta={[
				{ name: `description`, content: description },
				{ property: `og:title`, content: title },
				{ property: `og:description`, content: description },
				{ property: `og:type`, content: `website` },
				{ name: `robots`, content: robots },
			]}
			link={altLinks}
		/>
	)
}
